export default __webpack_public_path__ + "static/process-03-handshake-eb2cde50d267ec1a28adb067e18d1a70.png";